"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StipendType = void 0;
exports.instanceOfStipendType = instanceOfStipendType;
exports.StipendTypeFromJSON = StipendTypeFromJSON;
exports.StipendTypeFromJSONTyped = StipendTypeFromJSONTyped;
exports.StipendTypeToJSON = StipendTypeToJSON;
exports.StipendTypeToJSONTyped = StipendTypeToJSONTyped;
/**
 *
 * @export
 */
exports.StipendType = {
    Meals: 'MEALS',
    Lodging: 'LODGING',
    Incidentals: 'INCIDENTALS',
    Travel: 'TRAVEL'
};
function instanceOfStipendType(value) {
    for (const key in exports.StipendType) {
        if (Object.prototype.hasOwnProperty.call(exports.StipendType, key)) {
            if (exports.StipendType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function StipendTypeFromJSON(json) {
    return StipendTypeFromJSONTyped(json, false);
}
function StipendTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StipendTypeToJSON(value) {
    return value;
}
function StipendTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=StipendType.js.map